import React from 'react';
import { FaGraduationCap, FaBell, FaCalendarAlt, FaPhone, FaLock, FaBriefcase } from 'react-icons/fa';
import './Features.css';

const Features = () => {
  const handleButtonClick = () => {
    window.location.href = 'https://closeracademy.es/';
  };

  return (
    <section className="closer-academy">
      <h2>¿Qué encontrarás en Closer Academy?</h2>
      <p>
        Accederás a una comunidad de personas que están enfocadas en el desarrollo profesional y personal.
      </p>

      <div className="feature-list">
        <div className="feature">
          <div className="icon"><FaGraduationCap /></div>
          <h3>Formación Completa</h3>
          <p>Aprende desde 0 como generar ingresos con la habilidad de las ventas.</p>
        </div>

        <div className="feature">
          <div className="icon"><FaBell /></div>
          <h3>Módulos adicionales recurrentes</h3>
          <p>Trucos, estrategias para abordar clientes, psicología de la venta, etc.</p>
        </div>

        <div className="feature">
          <div className="icon"><FaCalendarAlt /></div>
          <h3>Sesiones semanales</h3>
          <p>Cada lunes hacemos una sesión que queda grabada para que no te pierdas nada.</p>
        </div>

        <div className="feature">
          <div className="icon"><FaPhone /></div>
          <h3>Ejemplos de Venta Reales</h3>
          <p>Casos reales de llamadas cada semana.</p>
        </div>

        <div className="feature">
          <div className="icon"><FaLock /></div>
          <h3>Plataforma privada y exclusiva</h3>
          <p>Acceso limitado a miembros con contenido exclusivo.</p>
        </div>

      </div>

      <button className="cta-button"  onClick={handleButtonClick}>QUIERO SABER MÁS</button>
    </section>
  );
};

export default Features;
